// tslint:disable: completed-docs
import produce from 'immer';
import {IInitialState} from './types';

import {
    TOGGLE_DEFAULT_NOTIFICATION,
    PRE_SELECT_MULTIPICKER_SUCCESS,
    SELECT_MULTIPICKER,
    SELECT_MULTIPICKER_SUCCESS,
    SET_DEFAULT_STATE,
} from './constant';
import {
    GET_OFFERS_FAILED,
    GET_OFFERS_SUCCESS,
    GET_OFFERS,
    GET_ADDITIONAL_CONTENTS,
    GET_ADDITIONAL_CONTENTS_SUCCESS,
    GET_ADDITIONAL_CONTENTS_FAILED,
} from './constant';

// tslint:disable-next-line: completed-docs
export const initialState: IInitialState = {
    error: false,
    errorMessage: false,
    loading: false,
    pageName: false,
    default_offer_ids: false,
    default_notification_is_displayed: false,
    has_mobilfunk: false,
    has_internet: false,
    has_tv: false,
    has_none: false,
    wants_mobilfunk: false,
    wants_internet: false,
    wants_tv: false,
    wants_redplus: false,
    recently_clicked_option: false,
    offer_json_url: false,
    offers: false,
    additionalContentLoading: false,
};

/**
 * Update list of simOnly in state or the error in case of API failed
 *
 * @export {function} preDataHandlerReducer
 * @param {*} state - Initial state of the app
 * @param {*} action - The action dispatched from saga
 */
const landingpageReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case SET_DEFAULT_STATE:
                draft.loading = true;
                draft.pageName = action.additionalCMSOptions.pageName;
                draft.default_offer_ids = action.additionalCMSOptions.default_offer_ids;
                break;
            case SELECT_MULTIPICKER:
                draft.recently_clicked_option = action.value;
                draft[action.value] = action.checked;
                break;
            case SELECT_MULTIPICKER_SUCCESS:
            case PRE_SELECT_MULTIPICKER_SUCCESS:
                draft.has_internet = action.offerKeys.has_internet;
                draft.has_mobilfunk = action.offerKeys.has_mobilfunk;
                draft.has_tv = action.offerKeys.has_tv;
                draft.has_none = action.offerKeys.has_none;
                draft.wants_internet = action.offerKeys.wants_internet;
                draft.wants_mobilfunk = action.offerKeys.wants_mobilfunk;
                draft.wants_tv = action.offerKeys.wants_tv;
                draft.wants_redplus = action.offerKeys.wants_redplus;
                break;
            case TOGGLE_DEFAULT_NOTIFICATION:
                draft.default_notification_is_displayed = action.showNotification;
                break;
            /**
             * GET_OFFERS .... just reads the JSON and checks, if it's valid
             */
            case GET_OFFERS:
                draft.offer_json_url = action.jsonUrl;
                break;
            case GET_OFFERS_SUCCESS:
                draft.offers = action.offers;
                draft.error = false;
                draft.loading = false;
                break;
            case GET_OFFERS_FAILED:
                draft.errorMessage = action.errorMessage;
                draft.error = true;
                break;
            case GET_ADDITIONAL_CONTENTS:
                draft.additionalContentLoading = true;
                break;
            case GET_ADDITIONAL_CONTENTS_SUCCESS:
                draft.additionalContentLoading = false;
                draft.error = false;
                break;
            case GET_ADDITIONAL_CONTENTS_FAILED:
                draft.error = action.error;
                draft.additionalContentLoading = false;
                break;
        }
    });

export default landingpageReducer;
